/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const SituationRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.SITUATION.VERTI_CLIENT.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/situation/verti-client/verti-client.module').then(
        m => m.VertiClientPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.SITUATION.FAMILY_SITUATION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/situation/family-situation/family-situation.module').then(
        m => m.FamilySituationPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.SITUATION.INSURANCE_START_DATE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/situation/policy-starting-date/policy-starting-date.module').then(
        m => m.PolicyStartingDatePageModule
      ),
    canActivate: [NavigationGuard],
  },
];
